import React, { useEffect, useRef, useState } from "react";
import VanillaTilt from "vanilla-tilt";
import "./catalog.css";
import { usePreloadedImages } from "../../contexts/PreloadedImagesContext";

function Catalog() {
  const { catalogImages, catalogShadowImages, isLoaded } = usePreloadedImages();
  const cards = [
    {
      id: 1,
      text: "Барьер искрозащиты",
      image: "SparkProtectionT.png",
      shadowImage: "SparkProtectionTShadow.png",
      label: "Серия Т",
      description:
        "Корпус 12,5 и 17,5 мм Шина питания Широкое портфолио Монтаж на DIN-рейку",
      style: {
        width: "250px",
        height: "250px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 2,
      text: "Барьер искрозащиты",
      image: "SparkProtectionH.png",
      shadowImage: "SparkProtectionHShadow.png",
      label: "Серия Н",
      description: "Замена MTL4500 Монтаж на панели",
      style: {
        width: "250px",
        height: "250px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 3,
      text: "Барьер искрозащиты",
      image: "SparkProtectionHID.png",
      shadowImage: "SparkProtectionHIDShadow.png",
      label: "Серия ХИД",
      description: "Замена барьеров HiD* Монтаж на панели",
      style: {
        width: "250px",
        height: "250px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 4,
      text: "Искробезопасные и общепромышленные модули УЗИП",
      image: "UZIP.png",
      shadowImage: "UZIPShadow.png",
      label: "Серия Т",
      description:
        "SIL3 Горячая замена Для 2, 3, 4 линий Модульный дизайн Для сигнальных цепей",
      style: {
        width: "250px",
        height: "250px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 5,
      text: "Релейные модули",
      image: "RelayModules.png",
      shadowImage: "RelayModulesShadow.png",
      label: "Серия РН",
      description:
        "SIL3 Тестовые клеммы Корпус 12,5 и 22,5 мм Тройное резервирование",
      style: {
        width: "250px",
        height: "250px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 6,
      text: "Гальванические изоляторы",
      image: "GalvanicIsolators.png",
      shadowImage: "GalvanicIsolatorsShadow.png",
      label: "Серия Т",
      description:
        "Шина питания Широкое портфолио Монтаж на DIN-рейку Корпус 12,5 и 17,5 мм",
      style: {
        width: "250px",
        height: "250px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 7,
      text: "Источники питания",
      image: "PowerSupplies.png",
      shadowImage: "PowerSuppliesShadow.png",
      description:
        "Широкое портфолио Мощность от 10 до 960 Резервированные решения",
      style: {
        width: "150px",
        height: "150px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 8,
      text: "Мобильные устройства",
      image: "MobileDevices.png",
      shadowImage: "MobileDevicesShadow.png",
      label: "MIG",
      description:
        "Ex планшеты Еx сматрфоны Решения для суровых условий",
      style: {
        width: "200px",
        height: "200px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
    {
      id: 9,
      text: "HART коммуниткаторы",
      image: "HARTCommunicator.png",
      shadowImage: "HARTCommunicatorShadow.png",
      description:
        "Для 3оны 1 Поддержка HART 5/6/7 Wireless HART, HART IP Встроенная библиотека",
      style: {
        width: "180px",
        height: "180px",
        objectFit: "contain" as React.CSSProperties["objectFit"],
      },
    },
  ];
  useEffect(() => {
    if (isLoaded) {
      const tiltElements = document.querySelectorAll("[data-tilt]");
      VanillaTilt.init(Array.from(tiltElements) as HTMLElement[], {
        speed: 700,
        glare: true,
        "max-glare": 0.5,
        transition: true,
      });

      return () => {
        Array.from(tiltElements).forEach((el) => {
          (el as any).vanillaTilt?.destroy();
        });
      };
    }
  }, [isLoaded]);

  if (!isLoaded) {
    return (
      <div className="catalog-loading">
        <p>Загрузка каталога...</p>
        {/* Можно добавить скелетон-заглушку */}
      </div>
    );
  }

  return (
    <section className="catalog-options">
      <h2 className="catalog__heading">Категории оборудования</h2>
      <ul className="catalog__card-list">
        {cards.map((card) => (
          <li
            key={card.id}
            // className="catalog__card-list-item"
            className={`catalog__card-list-item${
              card.id === 9 ? " catalog__card-list-item--full" : ""
            }`}
            data-tilt
            data-tilt-glare
            data-tilt-speed="700"
          >
            <div className="catalog__card-list-top" style={{ gridArea: "top" }}>
              <p
                className="catalog__card-list-text"
                style={card.id === 4 ? { fontSize: "16px" } : {}}
              >
                {card.text}
              </p>
            </div>
            <div
              className="catalog__card-image-wrapper"
              style={{ gridArea: "image" }}
            >
              {card.shadowImage && (
                <img
                  src={catalogShadowImages[card.shadowImage]?.src || ""}
                  alt={`${card.text} тень`}
                  className="catalog__card-image-shadow"
                  style={card.style}
                />
              )}
              <img
                src={catalogImages[card.image].src}
                alt={card.text}
                className="catalog__card-image"
                style={card.style}
              />
            </div>
            {card.label && card.id !== 9 && (
              <div
                className="catalog__card-label"
                style={{ gridArea: "label" }}
              >
                <span>{card.label}</span>
              </div>
            )}
            <span
              className="catalog__card-description"
              style={{
                gridArea: "description",
                display: "block",
                whiteSpace: "pre-line",
              }}
            >
              {card.description.split(/(?=[А-ЯЁ])/).map((line, index) => {
                const isIntelis =
                  card.id === 9 && line.trim().startsWith("интелис");
                return (
                  <div key={index}>
                    {isIntelis ? (
                      <span className="intelis-font">{line.trim()}</span>
                    ) : (
                      line.trim()
                    )}
                  </div>
                );
              })}
            </span>
            <div
              className="catalog__card-list-footer"
              style={{ gridArea: "footer" }}
            >
              <p className="catalog__card-list-text-footer">Перейти в раздел</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Catalog;
